import { SRPCampaignRecommendations } from "~/features/saleRecommendations/components/SRPCampaignRecommendations";
import { SRPTopsellerRecommendations } from "~/features/saleRecommendations/components/TopsellerRecommendations";
import type { RecommendationPlacement } from "~/features/search/models/RecommendationPlacement";

export function getSearchResultRecommendation(
  resultAmount: number,
  resultPage: number,
  recommendationPlacement?: RecommendationPlacement,
) {
  if (!recommendationPlacement || resultPage !== 0) {
    return null;
  }

  if (recommendationPlacement.type === "SALES_CAMPAIGN") {
    return {
      position: recommendationPlacement.position,
      component: <SRPCampaignRecommendations key="similar-sales" />,
    };
  }

  if (recommendationPlacement.type === "TOPSELLER" && resultAmount >= 4) {
    return {
      position: recommendationPlacement.position,
      component: <SRPTopsellerRecommendations key="similar-topseller" />,
    };
  }

  return null;
}
